import { collectLinkedCompanies } from 'src/utils/mappers/eventForm/area.mapper';
import { companySideAreaParams } from './params.mapper';

export const getParentGroups = (company) => {
	const groups = [];
	const seen = new Set();

	for (const memberLink of company.groupLinksAsMember || []) {
		if (memberLink.unlinked || !memberLink.group?.id) continue;
		if (seen.has(memberLink.group.id)) continue;

		seen.add(memberLink.group.id);
		groups.push(memberLink.group);
	}

	return groups;
};

export const isCompanyGroupMember = (company) => {
	return Boolean(
		company && !company.isGroup && getParentGroups(company).length,
	);
};

const mapLinkedVenues = (company) => {
	return collectLinkedCompanies(company).map((linkedCompany) => {
		const paramsNode = companySideAreaParams(linkedCompany);

		return {
			id: `linked-${linkedCompany.id}`,
			labelGroup: linkedCompany.name,
			labelGroupTo: `/company/${linkedCompany.id}`,
			items: paramsNode.items.map((item) => ({
				...item,
				id: `${linkedCompany.id}-${item.id}`,
			})),
		};
	});
};

const mapParentGroupLink = (company) => {
	const groups = getParentGroups(company);

	if (!groups.length) return [];

	return [
		{
			id: 'parent-groups',
			label: groups.length === 1 ? 'Группа' : 'Группы',
			items: [
				{
					id: 'parent-groups-list',
					data: {
						options: groups.map((group) => ({
							id: `parent-group-${group.id}`,
							type: 'link',
							payload: {
								links: [
									{
										id: `parent-group-link-${group.id}`,
										label: group.name,
										link: { to: `/company/${group.id}` },
									},
								],
							},
						})),
					},
				},
			],
		},
	];
};

export const companySideAreaGroups = (company) => {
	if (company.isGroup) {
		return mapLinkedVenues(company);
	}

	return mapParentGroupLink(company);
};
